export const isAuthenticated = () => {
  return window.UFE.user.is_authenticated
}
